export default __webpack_public_path__ + "static/reportar_siniestro_de_auto-e73b02816c859e880d72fb807569f805.mp4";